import ProductIcons from './product-icons.json';
/** Method to predict Loan group icons based on keywords in group name */
export const ConsumerSVGIcons = (product: string) => {
  const productName = product.toLowerCase();
  const iconIndex = ProductIcons.findIndex((t) => t.keys.findIndex((key) => includes(productName, key.toLowerCase())) > -1);
  if (iconIndex > -1) {
    return ProductIcons[iconIndex].class;
  }
  return 'other-loan';
};

/** Method to  get Memberhip icons*/
export const AccountsSVGIcons = (membership: string) => {
  switch (membership.toLowerCase()) {
    case 'membership':
    case includes(membership, 'personal'):
    case includes(membership, 'streamline'):
      return 'personal-account';
    case 'business membership':
    case includes(membership, 'business'):
      return 'business-account';
    case 'youth membership':
    case includes(membership, 'youth'):
    case includes(membership, 'minor'):
      return 'youth-account';
    default:
      return 'other-loan';
  }
};

// capture products with custom types i.e. "CU motorcycle loan", "EV auto"
const includes = (parent: string, value: string): string => {
  if (parent.toLowerCase().includes(value.toLowerCase())) {
    return parent.toLowerCase();
  }
};
